import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { BookingWizard } from "./BookingWizard";

export const BookingSheet = ({ selection, session, onClose, onBooked, onAgenda }) => <Sheet open={Boolean(selection)} onOpenChange={(next) => { if (!next) onClose(); }}>
  <SheetContent side="bottom" className="hud-sheet booking-sheet" closeTestId="booking-close-button" data-testid="booking-sheet">
    <div className="sheet-grab" aria-hidden="true" />
    <SheetHeader><SheetTitle className="sr-only">Fissa incontro</SheetTitle></SheetHeader>
    {selection && <BookingWizard key={`${selection.venueId || "new"}-${selection.date || ""}`} initialVenueId={selection.venueId}
      prefill={selection} callNote={selection.callNote} callId={selection.callId} csrfToken={session.csrf_token} onBack={onClose}
      onBooked={(data) => { onBooked(data); onClose(); }} onAgenda={onAgenda} />}
  </SheetContent>
</Sheet>;